import React, { useEffect, useState, useRef }  from 'react';
import '../../styles/tipsTamplate.scss';

function stripHtml(html) {
    var tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = html;
    return tempDivElement.textContent || tempDivElement.innerText || "";
}

const TipsTamplate = ({ title, label, text, textSecond }) => {
    const tipsRef = useRef(); // Ref для відстеження елемента tips_info_info
    const [isOpenTips, setIsOpenTips] = useState(false);

    // Обробник для закриття TipsTamplate при кліці за його межами
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tipsRef.current && !tipsRef.current.contains(event.target)) {
                setIsOpenTips(false);
            }
        };

        // Додавання обробника події кліку
        document.addEventListener('mousedown', handleClickOutside);

        // Видалення обробника при розмонтуванні компонента
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className='tips_wraper' ref={tipsRef}>
            <div onClick={() => setIsOpenTips(!isOpenTips)} className='tips_info_img'>
                <img src="/img/Question.svg" alt="" />
            </div>
            {isOpenTips && 
                <div className='tips_info_info'>
                    <h4>{title}</h4>
                    {label &&
                    <label className={label === 'Safe' ? 'label_safe' : label === 'Dangerous' ? 'label_dangerous' : label === 'Unsafe' ? 'label_unsafe' : ''} htmlFor="">{label}</label>
                    }
                    <div className='tips_info_text_wrap'>
                        <div dangerouslySetInnerHTML={{ __html: text }} />
                        <div dangerouslySetInnerHTML={{ __html: textSecond }} />
                    </div>
                </div>
            }
        </div>
    );
};

export default TipsTamplate;